export default ({ 
  optionsFields, 
  disabledFields
}) => {
  
  const transfer = [
    {
      id: 'transporter_transfer_id',
      model: 'transporter_transfer_id',
      tag: 'BaseTreeSelect',
      rules: ['required'],
      props: {
        name: 'Transportadora',
        label: 'Transportadora',
        placeholder: 'Selecione',
        invalidLabel: 'Vincule ao menos uma transportadora',
        selectOptions: optionsFields.transporter_transfer_id,
        readOnly: disabledFields.transporter_transfer_id
      },
    },
    {
      id: 'transit_point_id',
      model: 'transit_point_id',
      tag: 'BaseTreeSelect',
      rules: ['required'],
      props: {
        name: 'Local de Coleta',
        label: 'Local de Coleta',
        placeholder: 'Selecione',
        invalidLabel: 'Selecione ao menos um local de coleta',
        selectOptions: optionsFields.transit_point_id,
      },
      // events: {
      //   input: 'filterStores'
      // }
    },
    {
      id: 'transit_point_delivery',
      model: 'transit_point_delivery',
      tag: 'BaseTreeSelect',
      rules: ['required'],
      props: {
        name: 'Local de Entrega',
        label: 'Local de Entrega',
        placeholder: 'Selecione',
        invalidLabel: 'Selecione ao menos um local de entrega',
        selectOptions: optionsFields.transit_point_delivery,
        readOnly: disabledFields.transit_point_delivery,
      },
    },
    {
      id: 'driver_id',
      model: 'driver_id',
      tag: 'BaseTreeSelect',
      props: {
        name: 'Motoristas',
        label: 'Motoristas',
        placeholder: 'Selecione',
        suggestions: 'searchDriversWithTransitPoint',
        readOnly: disabledFields.driver,
      },
      events: {
        input: 'filterDrivers'
      }
    },
    {
      id: 'name',
      model: 'name',
      tag: 'InputGroup',
      rules: ['required'],
      props: {
        label: 'Título da Rota',
        invalidLabel: 'Insira um nome para a rota'
      }
    }
  ]

  const actions = [
    {
      id: 'confirm',
      tag: 'BaseButton',
      props: {
        label: 'Confirmar',
        theme: 'icon-right',
        color: 'primary-base',
        textColor: 'white',
        icon: 'save',
        type: 'submit',
        filled: true,
        disabled: disabledFields.save
      }
    }
  ]

  return [
    ...transfer,
    ...actions
  ]

}